import constants from '@/config/constants';
import { logger as loggerSentry } from '@sentry/react-native';

export function logError(
  message: string,
  error?: any,
  meta?: { [key: string]: any },
) {
  if (constants.sentryEnabled) {
    loggerSentry.error(message, {
      error,
      ...meta,
    });
    return;
  }
  /* eslint-disable no-console */
  if (constants.environment === 'production') {
    return;
  }
  if (message) {
    console.error('\x1b[41m\x1b[37m ERROR', message);
  }
  if (error) {
    console.error(error);
  }
}

export function logInfo(message: any, ...addInfo: any[]) {
  if (constants.environment === 'production') {
    return;
  }
  if (message) {
    console.info(message, ...addInfo);
  }
}
